import styles from './styles.module.scss';
import Border from 'components/Border';
import Button from 'components/UI/Button';
import WelcomeUserIcon from 'assets/img/pic/welcome_user.png';
import { IUser } from 'types/users';
import { useState, useEffect, useMemo } from 'react';

export default function AgreementUsers({
	onAccept,
	onCancel,
	onNoneSelected,
	users,
}: {
	onAccept: (user: Partial<IUser>) => void;
	onCancel: () => Promise<void> | void;
	onNoneSelected: () => void;
	users: Partial<IUser>[];
}) {
	const [selectedUser, setSelectedUser] = useState<Partial<IUser> | null>(null);

	const uniqueUsers = useMemo(() => {
		const seen = new Set();
		return users.filter(user => {
			if (!user?.num || seen.has(user.num)) return false;
			seen.add(user.num);
			return true;
		});
	}, [users]);

	useEffect(() => {
		if (uniqueUsers.length === 1) {
			setSelectedUser(uniqueUsers[0]);
		}
	}, [uniqueUsers]);

	const handleUserSelect = (user: Partial<IUser>) => {
		setSelectedUser(user);
	};

	const handleConfirm = () => {
		if (selectedUser) {
			onAccept(selectedUser);
		}
	};

	return (
		<Border>
			<div className={styles.agreement}>
				<img src={WelcomeUserIcon} />
				<div className={styles.usersList}>
					{uniqueUsers.map((user: Partial<IUser>, index: number) => (
						<div
							key={user.num || index}
							className={`${styles.userItem} ${selectedUser === user ? styles.userItemSelected : ''}`}
							onClick={() => handleUserSelect(user)}
						>
							{[user.secondname, user.firstname, user.middlename].filter(Boolean).join(' ')}
						</div>
					))}
				</div>
				<div className={styles.buttonsContainer}>
					<Button variant="violet" type="button" onClick={onCancel} size="lg">
						Назад
					</Button>
					<Button variant="green" type="button" onClick={handleConfirm} disabled={!selectedUser} size="lg">
						Подтвердить
					</Button>
				</div>
			</div>
		</Border>
	);
}
